import mockCommunityImage from '@assets/backgrounds/models.png';
import mockPlanningImage from '@assets/backgrounds/waves.png';

export const MOCK_CHAT_ID = 'mock_chat';

export const MOCK_CHAT = {
    id: MOCK_CHAT_ID,
    chat_id: MOCK_CHAT_ID,
    user_id: 'mock_juliana',
    username: 'Juliana Maria',
    handle: '@julianamaria',
    avatar: '',
    email: 'juliana.maria@exemplo.com',
    unread_messages: 0,
    updated_at: '2026-08-23 11:27:36',
    last_message_at: '2026-08-23 11:27:36',
    last_message: {
        content: { text: 'Combinado! Depois me conta como foi 😊' },
        created_at: '2026-08-23 11:27:36',
    },
    is_mock: true,
};

const MOCK_CONVERSATION = [
    ['received', 'Oi! Tudo bem? Vi seu comentário na comunidade e resolvi te chamar por aqui.'],
    ['sent', 'Oi, Juliana! Tudo ótimo, e com você? Que bom que chamou.'],
    ['received', 'Tudo certo também 😊 Você já começou a aula sobre planejamento semanal?'],
    ['sent', 'Comecei ontem. Gostei bastante da parte sobre organizar as prioridades.'],
    ['received', 'Sim! Aquela divisão entre urgente e importante clareou muita coisa para mim.'],
    ['sent', 'Para mim também. Eu costumava colocar tudo como urgente e acabava travando.'],
    ['received', 'Exatamente! Estou testando escolher só três prioridades principais por dia.'],
    ['sent', 'Boa ideia. Você está usando alguma ferramenta para acompanhar?'],
    ['received', 'Estou usando uma lista simples no celular e revisando antes de dormir.'],
    ['sent', 'Parece prático. Acho que vou começar assim antes de montar algo mais elaborado.'],
    ['received', 'Foi o que funcionou para mim. Quanto mais simples, mais fácil manter a constância.'],
    ['sent', 'Faz sentido. Você conseguiu participar do encontro ao vivo de sexta?'],
    ['received', 'Consegui! A conversa sobre criar uma rotina possível foi muito boa.'],
    ['received', '', { asset_type: 'IMAGE', asset_url: mockCommunityImage }],
    ['sent', 'Eu perdi, mas deixei salvo para assistir hoje à noite.'],
    ['received', 'Vale a pena. Tem um exercício no final que ajuda a montar a semana real, sem exagerar.'],
    ['received', 'Essa foi a imagem que usei como inspiração para organizar meus blocos.', {
        asset_type: 'IMAGE',
        asset_url: mockPlanningImage,
    }],
    ['sent', 'Ótimo, era justamente o que eu precisava. Minha agenda anda bem apertada.'],
    ['received', 'A minha também. Estou tentando reservar pequenos blocos em vez de esperar duas horas livres.'],
    ['sent', 'Essa mudança deve ajudar bastante. Vinte minutos já são melhores do que não começar.'],
    ['received', 'Total! Hoje consegui revisar uma aula inteira em dois blocos curtos.'],
    ['sent', 'Que bom! Vou testar essa estratégia ainda hoje.'],
    ['received', 'Depois me fala se funcionou. Se quiser, posso compartilhar como organizei os blocos.'],
    ['sent', 'Quero sim, seria ótimo ter uma referência.'],
    ['received', 'Claro! Eu separo um bloco para assistir, um para anotar e outro bem curto para revisar.'],
    ['received', 'Primeiro eu deixo o material aberto e tiro todas as distrações.'],
    ['received', 'Depois faço as anotações sem tentar deixar tudo perfeito.'],
    ['sent', 'Gostei da sequência. Vou adaptar para minha rotina desta semana.'],
    ['received', 'Combinado! Depois me conta como foi 😊'],
];

let mockElapsedSeconds = 8 * 60 * 60 + 14 * 60;
let previousDirection;

export const MOCK_CHAT_MESSAGES = MOCK_CONVERSATION.map(([direction, text, asset], index) => {
    if (index > 0) {
        mockElapsedSeconds += direction === previousDirection ? 24 : 8 * 60;
    }
    previousDirection = direction;

    const hour = Math.floor(mockElapsedSeconds / 3600);
    const minute = Math.floor((mockElapsedSeconds % 3600) / 60);
    const second = mockElapsedSeconds % 60;
    const time = [hour, minute, second]
        .map((part) => String(part).padStart(2, '0'))
        .join(':');

    return {
        id: `mock-message-${index + 1}`,
        sender_id: direction === 'received' ? MOCK_CHAT.user_id : 'mock_current_user',
        content: { text },
        created_at: `2026-08-23 ${time}`,
        ...(asset || {}),
    };
});

export function isMockChat(chatInfo) {
    return Boolean(
        chatInfo?.is_mock
        || String(chatInfo?.chat_id) === MOCK_CHAT_ID
        || String(chatInfo?.id) === MOCK_CHAT_ID
    );
}
